export const updateValueByPath = (object: Record<string, any>, value: any, path: string) => {
	const keys = path.split('.');
	const lastKey = keys.pop();
	if (lastKey) {
		const lastObj = keys.reduce((acc, key) => acc[key], object);
		lastObj[lastKey] = value;
	}
	return object;
};

export const getValueByPath = (object: Record<string, any>, path: string) => {
	const properties = path.split('.');
	return properties.reduce((acc, key) => acc?.[key], object);
};
